import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigation} from 'react-navi'
import {useAppState} from '../../../../state'

import {MainLayoutWithoutStretch, MainContent} from '../../../Layout/Layout'
import {Helmet} from 'react-navi-helmet-async'
import {HeaderActions, HeaderRow, HeaderTitle} from '../../../Molecules/ViewComponents/ViewHeader'
import {InstructionsDocument} from 'state/instructions/state'
import {openInNewTab} from '../../../../config/utils'
import {Loader} from '../../../../Routes'
import DocumentList from '../DocumentList'
import {ErrorMessage} from '../../../Molecules/Errors/ErrorMessage'
import {UserLanguage} from 'state/rest'

export const InstructionsView = () => {
  const nav = useNavigation()
  const {state, actions} = useAppState()
  const {t, i18n} = useTranslation('documents')
  const superUser = state.me?.accessRights.superuser === true

  useEffect(() => {
    const setup = async () => {
      actions.v1.instructions.getInstructionsDocuments()
      actions.v1.instructions.getInstructionsFolders(superUser ? undefined : (i18n.language as UserLanguage))
    }
    setup()
  }, [actions.v1.instructions, i18n.language])

  const {
    documentGroups,
    documentsPending,
    documentFoldersPending,
    documentFoldersError,
    documentsError
  } = state.v1.instructions

  const isLoading = documentsPending || documentFoldersPending
  const error = documentsError ? documentsError : documentFoldersError ? documentFoldersError : null

  const handleDownload = async (d: InstructionsDocument) => {
    if (d.url) {
      openInNewTab(d.url)
    } else if (d.asset && d.asset.id) {
      try {
        const data = await actions.getDownloadUrl(d.asset.id)
        openInNewTab(data.downloadURL)
      } catch (error) {
        // TODO display note about failure
      }
    }
  }

  const handleEdit = (id: string) => {
    nav.navigate('/instructions/' + id)
  }

  return (
    <MainLayoutWithoutStretch>
      <Helmet title={t('common:routes.instructions', 'Instructions')} />
      <Loader show={isLoading} />
      {!isLoading && (
        <MainContent variant="white">
          <HeaderRow
            description={t(
              'documents:instructions.messages.viewDescription',
              'In instructions view, you can find guides on how to use Chefstein.'
            )}
          >
            <HeaderTitle>{t('documents:instructions.title', 'Instructions')}</HeaderTitle>
            {superUser && (
              <HeaderActions
                onConfigure={() => nav.navigate('/instructions/folders')}
                onAdd={() => nav.navigate('/create/instructionsDocument')}
              />
            )}
          </HeaderRow>
          {error === null ? (
            <DocumentList
              documentGroups={documentGroups as any}
              onClick={handleDownload}
              onConfigure={superUser ? handleEdit : undefined}
              canManageDocument={() => superUser}
              useSettingsIcon={superUser}
            />
          ) : (
            <ErrorMessage message={error.message} />
          )}
        </MainContent>
      )}
    </MainLayoutWithoutStretch>
  )
}
